import { useQuery } from '@tanstack/react-query';
import * as Dfns from 'date-fns/fp';
import { DATE_FORMAT } from '@blisspointmedia/bpm-types/dist/RelativeDatePicker';
import { awaitJSON, DagLambdaFetch } from '../../utils/fetch-utils';
import { KpiStatusClientResponse, KpiStatusDisplayRow } from './kpi-status-constants';
import { getStatusType } from './kpi-status-utils';

export const useKpiStatus = (): ReturnType<typeof useQuery<KpiStatusDisplayRow[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['kpiStatus'],
    queryFn: async (): Promise<KpiStatusDisplayRow[]> => {
      const res = await DagLambdaFetch('/kpi_status/get', {
        params: { start: Dfns.format(DATE_FORMAT, Dfns.subWeeks(1, new Date())) }
      });

      const parsedResult = await awaitJSON<Record<string, KpiStatusClientResponse>>(res);

      const allRows = Object.values(parsedResult).flatMap(client => client.statuses ?? []);

      return allRows.map(row => ({ ...row, status_type: getStatusType(row) }));
    }
  });
